import React, { useState, useEffect } from "react";

const Blog = () => {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    const localPosts = JSON.parse(localStorage.getItem('posts'));
    if (localPosts) {
      setPosts(localPosts);
    }
  }, []);

  useEffect(() => {
    localStorage.setItem('posts', JSON.stringify(posts));
  }, [posts]);

  const addPost = (post) => {
    let newPost = {
      id: posts.length + 1,
      title: post.title,
      content: post.content
    };

    setPosts([...posts, newPost]);
  };

  const deletePost = (id) => {
    let newPosts = posts.filter((post) => post.id !== id);
    setPosts(newPosts);
  };

  return (<>
      <h1>Welcome to my blog!</h1>
      {posts.map((post) => (
        <div key={post.id}>
          <h2>{post.title}</h2>
          <p className="no-over">{post.content}</p>
          <button onClick={() => deletePost(post.id)}>Delete Post</button>
        </div>
      ))}
      <h2 className="middle-text">Add a Post<br/><p className="under-construction white no-over">Under Construction</p></h2>

    

      <input
        type="text"
        placeholder="Post title"
        id="title"
      />
      <input
        type="text"
        placeholder="Post content"
        id="content"
      />
      <button onClick={() => addPost({title: document.getElementById('title').value, content: document.getElementById('content').value})}>
        Add Post
      </button>





        <section>
<h2  className="blog-post-header">Thinkin...</h2>
            <p className="blog-post no-over">It's definitely one thing at a time with web development. There is SOO much to do with every aspect, so when one thing isn't right here, it's safe to say that I am working on it, I will get to it all in due time. At least we are here right?! </p>
          </section>





<section>
<h2  className="blog-post-header"> In case you didn't know Regex</h2>
            <p className="blog-post no-over ">

            A custom regex string is a type of code that allows you to define a pattern of characters. Regex strings are made up of literal characters and metacharacters. Literal characters are simply characters that will match themselves, such as letters, numbers, and symbols. Metacharacters are special symbols that act as wildcards and have a specific meaning. The syntax for a regex string is made up of the literal characters and metacharacters in a specific order and pattern.

Explain the sytax rules and system for Regex:

1. The start of the regex string is always indicated with a forward slash “/”.

2. To indicate what part of the string should match and should not match, you can use the question mark (“?”) character.

3. The asterisk (“*”) character can be used to indicate that the preceding character can be matched zero or more times.

4. The plus (“+”) character can be used to indicate that the preceding character can be matched one or more times.

5. To match multiple characters at once, you can use parentheses. For example, (abc) will match “abc” exactly.

6. The pipe (“|”) character can be used to indicate an “or” condition. For example, abc|def will match either “abc” or “def”.

7. The caret (“^”) and dollar sign (“$”) characters can be used to match the start and end of a string respectively. For example, ^abc$ will match “abc” exactly.

8. The backslash (“\”) character can be used to escape any of the special characters. For example, \+ will match the literal “+” character.

9. The dot (“.”) character can be used to match any character. For example, a.c will match “abc”, “aac”, “a1c”, and so on.

10. To match a predefined set of characters, you can use square brackets. For example, [abc] will match either “a”, “b”, or “c”.

11. To match a range of characters, you can use the dash (“-”) character. For example, [a-c] will match any character from “a” to “c”.

12. Finally, to indicate a repetition of the previous character or group of characters, you can use a number. For example, a{2} will match “aa”, but not “a” or “aaa”.

Regex strings are powerful tools that can be used to match or replace text based on a pattern. With the right syntax, almost any text can be manipulated.

            </p></section>
<section>
        <h2  className="blog-post-header"> Is there any other language like Regex? Is Regex a 'language'? </h2>
   <p className="blog-post no-over">
Regex is not a language, but rather a subset of the syntax of various programming languages. Regex is a specific way of writing a pattern that can then be used as part of a programming language such as JavaScript or Python. While there are other ways of writing patterns, Regex is the most commonly used. Other programming languages such as Java and C# also have their own syntax for patterns.

How is it compiled or understood? will it work and run and be understood in any application file?

Regex is usually compiled by a regex engine, which is a program that converts the regex string into a form that can be understood and executed by the computer. A regex engine will take a regex string and parse it, checking for errors and then converting it into a form that can be used. Some applications may have their own regex engine, while others may use a language-specific one. In either case, the regex engine will provide the same end result. Therefore, a regex string should work and be understood in any application file that has a regex engine.

How do you create a regex engine? Why would 'their own regex engine' ever and even be necessary?

Creating a regex engine requires knowledge of computer programming. The regex engine must have the ability to read a regex string and determine what the pattern should match, as well as any possible errors. To do this, the engine will use an algorithm to analyze the string and determine the pattern. A regex engine can be useful in applications where matching a pattern is necessary, such as a search engine or a text editor. Having one’s own regex engine can also make it easier to debug any issues that may arise, as the user is familiar with the code.

In conclusion, a regex string is a type of code that allows you to define a pattern of characters. Regex strings are made up of literal characters and metacharacters, and the syntax is made up of these components in a specific order and pattern. Regex strings are usually compiled by a regex engine, which is a program that converts the regex string into a form that can be understood and executed by the computer. Creating a regex engine requires knowledge of computer programming, and it can be useful in applications where matching a pattern is necessary.

Are there many Regex algorithms?

There are many different algorithms that can be used to interpret regex strings. The most common algorithm is the Thompson NFA algorithm, which is used to convert a regex string into a finite automaton. This algorithm is used by many different applications and programs, as it is the most efficient way to parse a regex string. There are also other algorithms, such as the Backtracking algorithm, which can be used to solve more complex problems. Each of these algorithms has its own advantages and disadvantages, and which one is used will depend on the application and the complexity of the problem.

What is the code for that algorithm and how do I add it to my application's regex engine?

The code for the Thompson NFA algorithm can be found in many open source libraries. For example, the Thompson NFA algorithm is available in the Boost library, and it can be used in an application’s regex engine by including the appropriate header file in the code. You can also use a parser generator to generate the code for the algorithm, or write the code yourself. The exact process for adding the code to a regex engine will depend on the specific application and programming language being used.</p>
        
</section>
        
 <a href="/" className="back-link bottom">Back to home</a>

   
      

</> );
};

export default Blog;







